export const config = {
  backendUrl:
    (import.meta.env.VITE_BACKEND_URL as string | undefined) ?? 'https://api.chemedu.site',
  firebaseConfigured: Boolean(
    (import.meta.env.VITE_FIREBASE_API_KEY as string | undefined) &&
    (import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined),
  ),
  appName: 'Bimbingan',
  appTagline: 'Bimbingan skripsi, satu alur yang jelas.',
  isDev: import.meta.env.DEV,
} as const;

export type Config = typeof config;
